module.exports = __webpack_public_path__ + "fonts/montserrat-regular-webfont.6fedfc64a7bfbbb272c4e4d3b8597244.svg?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.svg
// module id = 715
// module chunks = 9